module.exports = __webpack_public_path__ + "FI.png?4fb83a336b41fed79d338342ca09d3a5";